import { ShowerIcon } from './ShowerIcon';

/**
 * author: Augustin Ursu
 * id 1F29D513-0EFE-454A-B766-579A010C51B6
 * name shower
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shower.svg
 * tags
 * - Home Automation 
 */
export const BathroomIcon = ShowerIcon;
export default BathroomIcon